const EDITABLE_STATUSES = new Set(["APPROVED", "REJECTED", "PAUSED"]);
const NON_DELETABLE_STATUSES = new Set(["DISABLED"]);

export function isTemplateEditable(status: string): boolean {
  return EDITABLE_STATUSES.has(status.trim().toUpperCase());
}

export function isTemplateDeletable(status: string): boolean {
  return !NON_DELETABLE_STATUSES.has(status.trim().toUpperCase());
}

export function isCategoryEditable(status: string): boolean {
  return status.trim().toUpperCase() !== "APPROVED";
}
